import { Enums } from '@cyborg-monorepo/hunter/common'

// HUN-1325: Verity-linked companies are provisioned without an expiry date and
// can't currently expire, so the trial countdown is meaningless for them (and
// a null `expires` renders as "0 days left"). Hide it for anyone coming from
// Verity: inside the Verity iframe, or on a company with a Verity customer code.
export function shouldShowTrialBanner(
  isIframe: boolean,
  verityCustomerCode: string | null | undefined,
  companyStatus: Enums.CompanyStatus | undefined,
): boolean {
  if (companyStatus !== Enums.CompanyStatus.TRIAL) return false
  if (isIframe) return false

  return !verityCustomerCode
}
